(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabbed-services"] && !Shopify.designMode) return;
  try {
    

  $(".tabNav-solution-type li").on("mouseover", function() {

    let imgTarget = $(this).data("targetit");
    $(this).siblings().removeClass("active"); 
    $(this).addClass("active")
    console.log("Img Target: ",imgTarget); 

    $("#" + imgTarget).toggleClass("is-active");
    // $("#" + imgTarget).toggleClass("is-hover");

        $("#" + imgTarget)
        .siblings()
        .removeClass("is-active"); 

});
 
  
// $(".tabNav-solution-type li").on("click", function() {

//     let imgTarget = $(this).data("targetit");
//   $(this).siblings().removeClass("active");
//   $(this).addClass("active")

//     $("#" + imgTarget).toggleClass("is-active");

//     $("#" + imgTarget)

//         .siblings()

//         .removeClass("is-active");

// });
  

  } catch(e) { console.error(e); }
})();
})();
